import '../app.es6';
import angular from 'angular';

class ResourceBuilder {
  constructor (ConfiguredRestangular) {
    this.Restangular = ConfiguredRestangular;
    this.current = this.Restangular;

    ResourceBuilder.$inject = ['ConfiguredRestangular'];
  }

  get restangular () {
    return this.Restangular;
  }

  get currentRestangular () {
    return this.current;
  }

  players () {
    this.current = this.current.all('players');
    return this;
  }

  player (playerId) {
    this.current = this.current.one('players', playerId);
    return this;
  }

  postPlayer (params) {
    this.current = this.current.all('players').post(params);
    return this;
  }

  coaches () {
    this.current = this.current.all('coaches');
    return this;
  }

  coach (coachId) {
    this.current = this.current.one('coaches', coachId);
    return this;
  }

  profile () {
    this.current = this.current.one('profile');
    return this;
  }

  schools () {
    this.current = this.current.all('schools');
    return this;
  }

  school (schoolId) {
    this.current = this.current.one('schools', schoolId);
    return this;
  }

  groups () {
    this.current = this.current.all('groups');
    return this;
  }

  group (groupId) {
    this.current = this.current.one('groups', groupId);
    return this;
  }

  signupLinks () {
    this.current = this.current.all('signup-links');
    return this;
  }

  shots () {
    this.current = this.current.all('shots');
    return this;
  }

  summary () {
    this.current = this.current.all('summary');
    return this;
  }

  companies () {
    this.current = this.current.all('companies');
    return this;
  }

  company (companyId) {
    this.current = this.current.one('companies', companyId);
    return this;
  }

  videos () {
    this.current = this.current.all('videos');
    return this;
  }

  video (videoId) {
    this.current = this.current.one('videos', videoId);
    return this;
  }

  postingUrl (tag) {
    this.current = this.current.one('posting-url', tag);
    return this;
  }

  order () {
    this.current = this.current.one('order');
    return this;
  }

  comments (type) {
    if (type !== 'player' && type !== 'coach') {
      throw new TypeError('Unexpected user type.');
    }
    this.current = this.current.one('comments', type);
    return this;
  }

  comment (commentId) {
    this.current = this.current.one('comments', commentId);
    return this;
  }

  postComment (params) {
    this.current = this.current.all('comments').post(params);
    return this;
  }

  user () {
    this.current = this.current.one('user');
    return this;
  }

  signOut () {
    this.current = this.current.one('sign-out');
    return this;
  }

  videoDelete () {
    this.current = this.current.one('delete-video');
    return this;
  }

  token () {
    this.current = this.current.one('token');
    return this;
  }

  videoMoveToGuest () {
    this.current = this.current.one('move-video-to-guest');
    return this;
  }

  generatePassword () {
    this.current = this.current.one('generate-password');
    return this;
  }

  sessions () {
    this.current = this.current.all('sessions');
    return this;
  }

  signIn () {
    this.current = this.current.all('sign-in');
    return this;
  }

  get (arg) {
    let result = this.current.get(arg);
    this.current = this.Restangular;
    return result;
  }

  getList (arg) {
    let result = this.current.getList(arg);
    this.current = this.Restangular;
    return result;
  }

  getObject (arg) {
    return this.get(arg).$object;
  }

  getListObject (arg) {
    return this.getList(arg).$object;
  }

  post (arg) {
    return this.current.post(arg);
  }

  put (arg) {
    return this.current.put(arg);
  }

  remove (arg) {
    return this.current.remove(arg);
  }
}

class Resource {
  /* @ngInject */
  constructor (ConfiguredRestangular) {
    this.Restangular = ConfiguredRestangular;
  }
  new () {
    return new ResourceBuilder(this.Restangular);
  }
}

angular.module('myApp').service('Resource', Resource);



// WEBPACK FOOTER //
// ./app/services/resource.es6